import React, {Component} from 'react';
import TestResultsModal from './TestResultsModal';
import AnswerSheetResults from './AnswerSheetResults';
import PieChart from 'react-minimal-pie-chart';
import {NotificationManager} from 'react-notifications';
import $ from 'jquery';
import api from '../../utils/api';
import send from '../../utils/ChatServer.js';
import TestTimer from './TestTimer';
import LockTimer from './LockTimer';
import { Document, Page, pdfjs } from 'react-pdf';
import { Scrollbars } from 'react-custom-scrollbars';
import QuestionTimer from './QuestionTimer';
import IdleModal from '../Video/IdleModal';
import IdleTimer from 'react-idle-timer'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


class Test extends Component {
    constructor(props){
        super(props);

        this.state = {
            currentQuestion: 0,
            currentAnswer: null,
            showTestResultDetail: false,
            loadingNext: true,
            sections: this.props.userLecture ? this.props.userLecture.sections : null,
            initialSection: this.props.userLecture ? this.props.userLecture.sections : null,
            activeSection: 0,
            sectionStarted: false,
            setTimer: false,
            timerId: null,
            userTime: 0,
            mode: '',
            testActive: false,
            started: false,
            timed: false,
            ranOutOfTime: false,
            showQuestionSection: -1,
            showSolution: false,
            showQuestionIndex: -1,
            switchTo: '',
            timeSinceLastQuestion: 0,
            wrong: -1,
            multiplier: 30,
            locked: false,
            lockTimer: null,
            lockTime: 0,
            totalWrong: 0,
            testScored: false,
            currentProgress: 0,
            totalQuestions: 0,
            answeredQuestions: 0,
            page: 0,
            questionClass: 'bounceInRight',
            idleModal: false,

        }

        this.testTimer = React.createRef();
        this.timer = React.createRef();
        this.questionTimer = React.createRef();
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)


    }

    _onAction(e) {

      }
     
    _onActive(e) {
        
    }
    
    _onIdle(e) {

        if(this.state.started && !this.state.showTestResultDetail){
            this.setState({idleModal: true});
        }

    }

    componentDidMount(){
        let testId = this.props.test.id ? this.props.test.id : (this.props.userLectureId) ? this.props.userLectureId : this.props.match.params.id;
        if(!testId){
            testId = this.props.user.user.Profile.CourseUser[0].Course.testId;
        }
        if(this.props.match.params.id){
            if(this.props.profile.role){
                this.props.onLoad(this.props.match.params.id, this.props.profile.id, this.props.user.id);
                //this.props.onLoad(this.props.match.params.id, this.props.user.id, this.props.courseUser[0], this.props.courseUser[0].subjectAttempt, this.props.courseUser[0].courseAttempt, this.props.userSubject, this.props.user.user.Profile.id, this.props.user.userId);
        
            }
            //this.props.getSubjectTestCopy(testId, this.props.user.user.Profile.id, this.props.user.id);
        }else {
            this.props.getUserTestCopy(testId, this.props.user.user.Profile.id, this.props.user.id);
        }
    }

    componentWillUpdate(nextProps, state){

        if(nextProps.test.concepts && this.state.showTestResultDetail === false){

            if(this.state.timerId && !this.state.testActive && this.state.showTestResultDetail){
                clearInterval(this.state.timerId);

                if(Math.ceil((nextProps.test.correctAnswers / nextProps.test.totalQuestions) * 100) >= 80){

                    //this.updateCourseUserNextVideo();
                }
            }

        }else if(nextProps.test.concepts && nextProps.test.courseSubjectId && this.state.showTestResultDetail && this.state.testScored === false){
            
            if(Math.ceil((nextProps.test.correctAnswers / nextProps.test.totalQuestions) * 100) >= 80){

                    this.setState({testScored: true}, () => {
                        //this.updateCourseUserNextVideo();
                
                    })
                }

        }

        if(nextProps.test.courseSubjectId && nextProps.test.testMode === 'timed'){
            if (!this.state.timerId && !this.state.setTimer) {
                if(nextProps.test.finish) {
                    this.setState({setTimer: true, userTime: nextProps.test.finish}, () => {


                    })
                }


            }
        }

        if(nextProps.userLecture){
            if(state.sections !== nextProps.userLecture.sections){
                this.setState({sections: nextProps.userLecture.sections});
            }
            if(nextProps.userLecture.sections){
                let section = nextProps.userLecture.sections[state.activeSection];
                let q = section.questions[state.currentQuestion];

                let os;
                if(this.props.userLecture){
                    if(this.props.userLecture.sections){
                        os = this.props.userLecture.sections[this.state.activeSection];
                    }
                } 

                let oq = {};
                if(this.props.userLecture && os){
                    oq = os.questions[state.currentQuestion];
                } 

                if(nextProps.userLecture.sections[state.activeSection].file && (state.src !== this.state.src || !state.src)) {
                    this.setState({showFile: false}, () =>{
                        this.setState({page: Number(q.page), showFile: true, src: api.makeFileURL(nextProps.userLecture.sections[state.activeSection].file, nextProps.user.id)}, () => {
                            //this.renderSubSectionFile(this.state.currentQuestion);
                        });    
                    })
                    
                }
            }
        }
    }

    removeTextLayerOffset() {
        const textLayers = document.querySelectorAll(".react-pdf__Page__textContent");
          textLayers.forEach(layer => {
            const { style } = layer;
            style.top = "0";
            style.left = "0";
            style.transform = "";
        });
      }

    renderSubSectionFile = (qi) => {
        let pn = [0];
        let rawPageArray = [];
        let rawPage = '';
        let src = '';
        if(this.state.sections[this.state.activeSection].file){
            src = this.state.sections[this.state.activeSection].file;
        }
        if(this.state.sections[this.state.activeSection].questions[this.state.currentQuestion]){
            if(this.state.sections[this.state.activeSection].questions[this.state.currentQuestion].page){
                rawPage = this.state.sections[this.state.activeSection].questions[this.state.currentQuestion].page;
            }
        }
        if(rawPage){
            if(rawPage.indexOf(',') > -1){
                rawPageArray = rawPage.split(',');
            }else{
                rawPageArray = [rawPage];
            }
        }

        rawPageArray.map(rpo => {
            
            if(rpo.indexOf('-') > -1){
                let splitPages = rpo.split('-');
                splitPages.map(sp => {
                    sp = sp.replace(/\D/g, '');
                });

                let num1 = Number(splitPages[0]);
                let num2 = Number(splitPages[1]);
                if(num1 && num2 && num2 > num1){
                    pn = [];
                    for(let i = num1; i <= num2; i++){
                        pn.push(i);
                    }
                }
            }else{
                pn = [];
                let rp = rpo.replace(/\D/g, '');
                if(!isNaN(Number(rp))){
                    pn.push(Number(rp));
                }
            }
        })
        if(src && pdfjs.GlobalWorkerOptions.workerSrc){
            return (
                <Scrollbars style={{ height: "calc(100vh - 100px)" }}>
                    <Document onMouseDown={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} file={api.makeFileURL(src, this.props.user.id)} error={e => console.log("err,", e)}>
                        {pn.map((pageNum, i) => {
                            return (
                                <Page key={i} error={''} noData={''}  width={$('.test-side-left').width()} pageNumber={Number(pageNum) || 0} onLoadSuccess={() => this.removeTextLayerOffset()} style={{width: '100%'}} />
                            )
                        })}
                        
                    </Document>

                </Scrollbars>
                
            )
        }
    }

    renderSubSectionFileOld = (qi) => {
        if(this.state.src && this.state.showFile) {
            let page = 0;
            if(this.props.userLecture.sections[this.state.activeSection].questions[qi]){
                page = this.props.userLecture.sections[this.state.activeSection].questions[qi].page
            }
            return (
                <div>
                    <div className="pdf-overlay" onMouseDown={e => {
                        
                        e.preventDefault();
                        return false;
                    }} onContextMenu={e => false}></div>
                    <embed style={{height: 'calc(100vh - 50px)'}} type="application/pdf" src={this.state.src + '#toolbar=0&page=' + page} 
                        id="fradisabled" 
                        onLoad={() => {
                        }}
                        onMouseDown={e => {
                        
                        e.preventDefault();
                        return false;
                    }} onContextMenu={e => false} />
                </div>
                
            )
        }else{
            return null
        }
    }

    mapCurrentQuestion(cur){
        if(this.props.userLecture) {
            let buttonClass = (this.state.loadingNext) ? " fadeOutLeft " :
                " fadeInLeft ";
            return (
                <div className={"question"}>
                    {this.props.userLecture.sections[this.state.activeSection].questions[cur].concept &&
                        <div className={"pull-right text-info concept-name"}>
                            <i><b>{this.props.userLecture.sections[this.state.activeSection].questions[cur].concept}</b></i>
                        </div>
                    }
                    <h4><h5>Question:</h5>{this.props.userLecture.sections[this.state.activeSection].questions[cur].question}</h4>

                    <div className={"answers"}>
                        <button className={"btn btn-default btn-transparent animated " + buttonClass + " step1"}
                                onClick={(e) => this.setState({currentAnswer: "A"})}
                        >
                            <span className={(this.state.currentAnswer === "A") ? "zmdi zmdi-dot-circle answer-option text-success" : "zmdi zmdi-circle-o  answer-option"}></span>

                            {this.props.userLecture.sections[this.state.activeSection].questions[cur].optionA}
                        </button>

                        <button className={"btn btn-default btn-transparent animated " + buttonClass + " step2"}
                                onClick={(e) => this.setState({currentAnswer: "B"})}
                        >
                            <span className={(this.state.currentAnswer === "B") ? "zmdi zmdi-dot-circle answer-option text-success" : "zmdi zmdi-circle-o  answer-option"}></span>

                            {this.props.userLecture.sections[this.state.activeSection].questions[cur].optionB}
                        </button>


                        <button className={"btn btn-default btn-transparent animated " + buttonClass + " step3"}
                                onClick={(e) => this.setState({currentAnswer: "C"})}
                        >
                            <span className={(this.state.currentAnswer === "C") ? "zmdi zmdi-dot-circle answer-option text-success" : "zmdi zmdi-circle-o  answer-option"}></span>

                            {this.props.userLecture.sections[this.state.activeSection].questions[cur].optionC}
                        </button>

                        <button className={"btn btn-default btn-transparent animated " + buttonClass + " step4"}
                                onClick={(e) => this.setState({currentAnswer: "D"})}
                        >
                            <span className={(this.state.currentAnswer === "D") ? "zmdi zmdi-dot-circle answer-option text-success" : "zmdi zmdi-circle-o  answer-option"}></span>

                            {this.props.userLecture.sections[this.state.activeSection].questions[cur].optionD}
                        </button>
                        <br/><br/>

                        <div className={"question-footer text-right"}
                             onClick={(e) => {
                                 if(this.props.userLecture.currentQuestion === this.props.userLecture.sections[this.state.activeSection].questions.length){
                                     this.props.userLecture.sections[this.state.activeSection].questions[cur].userAnswer = this.state.currentAnswer;
                                     this.props.userLecture.currentQuestion += 1;
                                     this.props.scoreTest(this.props.userLecture, this.props.user.user.Profile.id, this.props.user.id);
                                     this.setState({currentAnswer: null, showTestResultDetail: true})
                                 }else {
                                     this.props.userLecture.sections[this.state.activeSection].questions[cur].userAnswer = this.state.currentAnswer;
                                     this.props.userLecture.currentQuestion += 1;
                                     this.setState({currentAnswer: null, loadingNext: true, showTestResultDetail: true});
                                     this.props.updateTest(this.props.userLecture, this.props.user.id);


                                 }
                             }}
                        >
                            <button className="btn btn-base" disabled={(this.state.currentAnswer === null)}>Next</button>
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderConceptScores = () => {
        return this.props.userLecture.concepts.map((item, index) => {
            return (
                <div
                    className="col-md-3 text-center sp-20 diagnostic-score diagnostic-pie-chart"
                    key={index}
                >
                    <p>{item.name}</p>
                    <PieChart
                        style={{width: 100, margin: '0 auto'}}
                        data={[
                            {value: item.correctPercent, color: '#e3d9d8'},
                            {value: item.correctAnswers, color: '#e33339'}
                        ]}
                        totalValue={item.questionCount}
                        lineWidth={20}
                        rounded={true}
                    />
                    <p className="diagnostic-pie-chart-counter">{item.correctAnswers}/{item.questionCount}</p>
                </div>
            )
        })
    }

    renderTestHeader(){
        return (
            <div>
                <div className={"test-progress"}>
                    <div className={"pull-left"}>
                        {this.props.userLecture.currentQuestion <= this.props.userLecture.sections[this.state.activeSection].questions.length ?
                            <span>
                             Question {this.props.userLecture.currentQuestion} of {this.props.userLecture.sections[this.state.activeSection].questions.length}
                            </span>
                            :
                            <span>Results</span>

                        }
                    </div>
                    <div className="progress-count text-right">
                        {Math.ceil(((this.props.userLecture.currentQuestion - 1) / this.props.userLecture.sections[this.state.activeSection].questions.length) * 100 )}%
                    </div>

                    <div className="progress-bar-container">
                        <div className="progress-bar" style={{width: ((this.props.userLecture.currentQuestion - 1) / this.props.userLecture.sections[this.state.activeSection].questions.length) * 100  + "%"}}></div>
                    </div>
                </div>
            </div>
        )
    }

    stopTest = () => {
        let test = this.props.userLecture;
        if(this.testTimer){
            test.userTime = this.testTimer.current.state.userTime;
            test.testTime = this.testTimer.current.state.testTime;
            if(this.props.userLecture){
                if(this.props.userLecture.Lecture){
                    test.finish = this.props.userLecture.Lecture.finish;
                    test.timeLimit = this.props.userLecture.Lecture.timeLimit;
                }
            }
        }

        test.ranOutOfTime = true;

        if (this.props.userLecture.chapterVideoId) {
            test.finishedAt = test.timeLimit - test.userTime;
            this.props.scoreSubjectTest(test, this.props.user.user.Profile.id, this.props.user.id);
        } else {
            test.finishedAt = 1;
            this.props.scoreTest(test, this.props.user.user.Profile.id, this.props.user.id);
        }

        this.setState({currentAnswer: null, showTestResultDetail: true})


    }

    renderContentHeader = () => {
        //Renders


        return (
            <div className="b-b wrapper-md">
            <div className="row">
                <div className="col-sm-8">
                    <h1 className="m-n font-thin h3 text-black">{this.props.userLecture.name || this.props.userLecture.title}</h1>
                    <small className="text-muted"></small>

                </div>
               
                {this.state.started && this.props.userLecture.testType === "answer" && this.props.userLecture.testMode === 'practice' && this.state.lockTime > 0 ?
                    <LockTimer
                        start={this.state.lockTime}
                        onUnlock={this.onUnlock}
                        show={(this.state.lockTime > 0)}
                        />
                : this.state.started && this.props.userLecture.Lecture ?
                this.props.userLecture.Lecture.finish ?
                    <TestTimer 
                        ref={this.testTimer}
                        start={this.props.userLecture.userTime ? this.props.userLecture.userTime : this.props.userLecture.Lecture.finish}
                        testTime={this.props.userLecture.testTime ? this.props.userLecture.testTime : this.props.userLecture.Lecture.timeLimit}
                        totalQuestions={this.state.totalQuestions}
                        answeredQuestions={this.state.answeredQuestions}
                        show={this.props.userLecture.Lecture.testMode === 'timed'}
                        mode={this.props.userLecture.Lecture.testMode}
                        stop={e => this.stopTest()}
                        idle={this.state.idleModal}
                    />

                : null
            : null}
                <div className="col-sm-12">
                    <div className={`sm-top20 ${this.state.started ? 'hidden' : ''}`} id={`question-head-desc`}>
                        <div dangerouslySetInnerHTML={{__html: this.props.userLecture.instructions}}></div>
                        <div className="sm-top20 text-right">
                            {this.props.userLecture.testType === "answer" &&
                                <a href="#nogo" id="BeginTest" onClick={() => (this.props.userLecture.testMode === 'practice') ? this.startTest('training') : this.startTest('timed')} className="btn btn-danger w-sm">Begin</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
        return (
            <div className="bg-light lter b-b wrapper-md">
                <div className="row">
                    <div className="col-sm12 col-xs-12">
                        <h1 className="m-n font-thin h3 text-black">
                            <a className="back-button" onClick={(e) => {
                                e.preventDefault();
                                this.props.history.goBack();
                            }}>
                                <i className={"zmdi zmdi-arrow-left"}></i>
                            </a> {this.props.userLecture.name}
                        </h1>
                        <small className="text-muted">

                        </small>
                    </div>
                </div>
            </div>
        );
    }

    renderResults(){
        let resultClass = '';
        if(this.props.userLecture.correctPercent > 70){
            resultClass = "text-success";
        }else if(this.props.userLecture.correctPercent > 50){
            resultClass = "text-info";
        }else{
            resultClass = "text-danger";
        }
        return (
            <div>

                <div className="text-center">
                    <div className={"test-results " + resultClass}>
                    <span className="zmdi zmdi-star huge-icon"></span>
                    <span className="test-score">{Math.ceil(this.props.userLecture.correctPercent)}%</span>
                    </div>
                    <div className="results-detail">
                        <b>Correct Answers:</b> {this.props.userLecture.correctAnswers} / {this.props.userLecture.sections[this.state.activeSection].questions.length}<br /><br />
                        <br />

                        <div className={"concept-scores"}>
                            <div className={"row"}>
                            {this.props.userLecture.concepts &&
                                this.renderConceptScores()}
                            </div>
                        </div>
                        <br /><br />
                        <button className={"btn btn-default"} onClick={(e) => this.setState({showTestResultDetail: true})}>Show Answers</button> &nbsp;
                        <button className={"btn btn-base"} onClick={(e) => {

                            this.props.history.push('/dashboard');
                        }}>Complete Onboarding</button>
                    </div>
                </div>
            </div>
        )
    }

    onUnlock = () => {

        this.setState({
            locked: false,
            lockTimer: null,
            lockTime: 0
        });
    

    }

    lockForSeconds = (seconds) => {
        let lockTimer = setInterval(this.updateLockTimer, 1000);
        if(seconds > 300){
            seconds = 500;
        }
        this.setState({
            locked: true,
            lockTime: seconds,
            lockTimer: lockTimer

        });
    }
    
    renderCurrentMCATQuestion = (last) => {
        if(this.props.userLecture){
            let options = ["A", "B", "C", "D"];
            if(this.props.userLecture.Lecture.answer_choices == 5){
                options.push("E");
            }
            let question = this.props.userLecture.sections[this.state.activeSection].questions[this.state.currentQuestion];
            
        return (
            <div className="question-section question-section-1 active-question-set" data-question-set="1">
                            <div className="flex flex-eq-width">
                                <div className="flex-item test-side test-side-left sp-top-bottom40" style={{height: "90vh", overflowY: "hidden"}}>
                                    {this.renderSubSectionFile(this.state.currentQuestion)}
                                </div>
        
                                <div className="flex-item test-side test-side-right sp-top-bottom40" style={{background: "rgb(234, 234, 234)", height: "90vh", overflowY: "auto"}}>
                                    <div className="sp-50">
                                        
                                        <div className="solution-btn">
                                            {question.hint ?
                                                <a className="btn btn-info" onClick={e => this.setState({showSolution: !this.state.showSolution})} href="#nogo"> <i className="zmdi zmdi-help-outline"></i> Hint</a>
                                            : null}
                                            <a className="btn btn-success" onClick={e => {
                                                e.preventDefault();
                                                let {sections} = this.state;
                                                if(sections[this.state.activeSection].questions[this.state.currentQuestion].flagged){
                                                    sections[this.state.activeSection].questions[this.state.currentQuestion].flagged = false;
                                                }else{
                                                    sections[this.state.activeSection].questions[this.state.currentQuestion].flagged = true;
                                                }
                                                
                                                this.setState({sections});
                                            }} href="#nogo"> <i className="zmdi zmdi-flag"></i> {this.state.sections[this.state.activeSection].questions[this.state.currentQuestion].flagged  ? 'Unflag' : 'Flag'}</a>
                                        </div>
                                        
                                            <div className="" id="diag-question-1" data-question="1">
                                            <p className="font-18">Question {this.state.currentQuestion + 1}</p>
                                            <div dangerouslySetInnerHTML={{__html: question.question}}></div>

                                            {question.image &&
                                                <div className="sm-top-bottom20 text-center question-image">
                                                    <img src={api.makeFileURL(question.image, this.props.user.id)} />
                                                </div>
                                                }
                                            <ul className="list-unstyled sm-top50 mcqList mcqDark">
                                                {options.map((letter, li) => {
                                                    if(question["option" + letter] !== '<p><br></p>' && question["option" + letter] !== ''){
                                                    return (
                                                        <li key={li}><label>
                                                        <input 
                                                            name="radio1" 
                                                            type="radio" 
                                                            value={letter}
                                                            checked={this.state.currentAnswer === letter || this.state.sections[this.state.activeSection].questions[this.state.currentQuestion].userAnswer === letter}
                                                            onChange={e => {
                                                                let {sections, activeSection, currentQuestion} = this.state;
                                                                sections[activeSection].questions[currentQuestion].userAnswer = e.target.value;
                                                                this.setState({currentAnswer: e.target.value, sections})
                                                            
                                                            }} />
                                                            <div className="video-answer" dangerouslySetInnerHTML={{__html: question["option" + letter]}}></div>
                                            </label></li>
                                                    )
                                                        }else{
                                                            return null;
                                                        }
                                                })
                                                }
                                            </ul>
                                            
                                            {this.state.showSolution &&
                                            <div className="question-help" style={{display: "block"}}
                                            dangerouslySetInnerHTML={{__html: question.hint}}></div>
                                            }
                                        </div>
                                    </div>
                                    <div className="footer-test-side" style={{width: '100% !important'}}>
                                        <div className="flex flex-justify-content-flex-end">
                                            <div>
                                                {this.state.activeSection === 0 && this.state.currentQuestion === 0 ?
                                                    null:
                                                    
                                                    <a className="btn btn-default prev-diag-quest-btn"  onClick={e => {
                                                        if(this.state.currentQuestion > 0){
                                                            let self = this;
                                                            
                                                            self.setState({currentQuestion: self.state.currentQuestion - 1, showSolution: false, currentAnswer: self.state.sections[self.state.activeSection].questions[self.state.currentQuestion - 1].userAnswer, questionClass: 'bounceInLeft'});
                                                                
                                                        }
                                                    }} href="#nogo"><i className="zmdi zmdi-arrow-back"></i> Prev</a>
                                                }
                                            </div>
                                            <div>
                                                <a className="btn btn-default" href="#NavigationModal" data-toggle="modal"><i className="zmdi zmdi-grid"></i> Navigation</a>
                                            </div>
                                            <div>{last && this.state.currentAnswer !== "" ?
                                                    <a className="btn btn-default next-diag-quest-btn score-quiz" disabled={this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length > 0}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    let test = this.props.userLecture;
                                                                    test.sections = this.state.sections;
                                                                    test.practice = (!this.state.timed);
                                                                     let sections = this.props.userLecture.sections;
                                                                    let {currentQuestion, currentAnswer, activeSection, wrong, userTime} = this.state;
                                                                    
                                                                    sections[this.state.activeSection].questions[currentQuestion].userAnswer = currentAnswer;
                                                                    sections[this.state.activeSection].questions[currentQuestion].time = Number(this.questionTimer.state.time);
                                                                    this.questionTimer.reset();
                                                                    if(this.testTimer){
                                                                        if(this.testTimer.current){
                                                                            test.userTime = this.testTimer.current.state.userTime;
                                                                            test.testTime = this.testTimer.current.state.testTime;
                                                                            if(this.props.userLecture){
                                                                                if(this.props.userLecture.Lecture){
                                                                                    test.finish = this.props.userLecture.Lecture.finish;
                                                                                    test.timeLimit = this.props.userLecture.Lecture.timeLimit;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
        
                                                                    if (this.props.userLecture.chapterVideoId) {
                                                                        test.finishedAt = test.finish - this.state.userTime;
                                                                        test.testTime = this.testTimer.current ? this.testTimer.current.state.testTime : 0;
                                                                        this.props.scoreSubjectTest(test, this.props.user.user.Profile.id, this.props.user.id);
                                                                    } else {
                                                                        test.finishedAt = 1;
                                                                        this.props.scoreTest(test, this.props.user.user.Profile.id, this.props.user.id);
                                                                    }
                                                                    this.setState({currentAnswer: null, showTestResultDetail: true, testActive: false, questionClass: 'bounceOutLeft'});
        
                                                                }} href="#nogo">Score Quiz</a>
                                                : !last ?
                                                <a className="btn btn-default next-diag-quest-btn" onClick={e => {
                                                    let sections = this.props.userLecture.sections;
                                                    let {currentQuestion, currentAnswer, activeSection, wrong, userTime, sectionStarted} = this.state;
                                                    
                                                    
                                                    if(currentAnswer){
                                                    
                                                        sections[this.state.activeSection].questions[currentQuestion].userAnswer = currentAnswer;
                                                        sections[this.state.activeSection].questions[currentQuestion].time = Number(this.questionTimer.state.time);
                                                        this.questionTimer.reset();
                                            }
                                                    
                                                   
                                                    
                                                    if(sections[this.state.activeSection].questions.length -1 > currentQuestion){
                                                        currentQuestion += 1;
        
                                                    }else if(
                                                        sections.length - 1 > activeSection
                                                    ){
                                                        currentQuestion = 0;
                                                        activeSection += 1;
                                                        sectionStarted = false;
                                                    }
                                                    
                                                    
                                                     if(sections[activeSection].questions[currentQuestion].userAnswer){
                                                        currentAnswer = sections[activeSection].questions[currentQuestion].userAnswer;
                                                    }else{
                                                        currentAnswer = '';
                                                    }
                                                    
                                                    let totalQuestions = 0;
                                                    let answeredQuestions = 0;
                                                    
                                                    sections.map((s, i) => {
                                                        s.questions.map((q) => {
                                                            totalQuestions += 1;
                                                            if(q.userAnswer && q.userAnswer !== ""){
                                                                answeredQuestions += 1;
                                                            }
                                                        })
                                                    });
            
                                                    let progress = (answeredQuestions / totalQuestions) * 100;
                                                    let self = this;
                                                    
                                                    self.setState({
                                                        sections,
                                                        timeSinceLastQuestion: self.props.test.finish - self.state.userTime,
                                                        currentQuestion,
                                                        activeSection,
                                                        currentAnswer: currentAnswer,
                                                        wrong: -1,
                                                        currentProgress: parseInt(progress),
                                                        questionClass: 'bounceInRight',
                                                        showSolution: false,
                                                        sectionStarted,
                                                        answeredQuestions
                                                    });

                                                    let test = this.props.userLecture;
                                                    test.sections = this.state.sections;
                                                    this.props.updateTest(test, this.props.user.id);
                                                        
                                                    
                                                }} href="#nogo">Next <i className="zmdi zmdi-arrow-forward"></i></a>
                                                : null
                                            }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    }
    }
    
    renderCurrentQuizQuestion = (last) => {
        if(this.props.userLecture){
            let options = ["A", "B", "C", "D"];
            if(this.props.userLecture.Lecture.answer_choices == 5){
                options.push("E");
            }
            let question = this.props.userLecture.sections[this.state.activeSection].questions[this.state.currentQuestion];
            return (
                
                <div className={`LectureQuiz sp-20 animated ${this.state.questionClass}`} id="FinalQuizQuestion1" data-question="1" style={{display: 'block'}}>
                    {question.image &&
                    <div className="sm-top-bottom20 text-center question-image">
                        <img src={api.makeFileURL(question.image, this.props.user.id)} />
                    </div>
                    }
                    <p className="font-18" dangerouslySetInnerHTML={{__html: (this.state.currentQuestion + 1).toString() + ' - ' + question.question}}></p>
                    <ul className="list-unstyled sm-top50 mcqList mcqDark">
                                                {options.map(letter => {
                                                    if(question["option" + letter] !== '<p><br></p>' && question["option" + letter] !== ''){
                                                    return (
                                                        <li><label>
                                                        <input 
                                                            name="radio1" 
                                                            type="radio" 
                                                            value={letter}
                                                            checked={this.state.currentAnswer === letter || this.state.sections[this.state.activeSection].questions[this.state.currentQuestion].userAnswer === letter}
                                                            onClick={e => {
                                                                let {sections, activeSection, currentQuestion} = this.state;
                                                                sections[activeSection].questions[currentQuestion].userAnswer = e.target.value;
                                                                this.setState({currentAnswer: e.target.value, sections})
                                                            
                                                            }} />
                                                            <div className="video-answer" dangerouslySetInnerHTML={{__html: question["option" + letter]}}></div>
                                            </label></li>
                                                    )
                                                    }else{
                                                        return null;
                                                    }
                                                })
                                                }
                                            </ul>
                </div>
                                        
            )
        }
        
    }

    renderSingleQuestion(question, index, sectionIndex){
        let options = ["A", "B", "C", "D"];

        if(this.props.userLecture.Lecture.answer_choices == 5){
            options.push("E");
        }

        return (
            <div className={`table-question-row ${this.state.mode === "training" && this.state.currentQuestion !== index || this.state.locked ? 'disabled' : ''}`} >
                <ul>
                    <li className="question-number">{index + 1}</li>

                    {options.map(o => {
                        if(this.state.sections[this.state.activeSection].questions[index]){
                        return (
                            <li id={`${index}-${o}`} className={(this.state.sections[this.state.activeSection].questions[index].userAnswer === o) ?
                                "QuestionAble CorrectQuestion" : 
                                
                                    (this.state.wrong > -1) ? "QuestionAble" : "QuestionAble"}>

                                <button className={"btn btn-answer btn-transparent"} onClick={(e) => {
                                    e.preventDefault();
                                    let {sections, wrong, currentQuestion, activeSection} = this.state;
                                    if(this.state.mode === "training") {
                                        if (sections[this.state.activeSection].questions[index].correctOption !== o) {
                                            // got this wrong.
                                            wrong += 1;
                                            
                                            if(wrong > -1){
                                                $("#" + index + '-' + o).addClass('animated rubberBand');
                                                setTimeout(function(){
                                                    $("#" + index + '-' + o).removeClass('animated rubberBand');
                                                }, 500);
                                                sections[this.state.activeSection].questions[index].wrong = wrong;
                                            }
                                            if(wrong > 0){
                                                this.lockForSeconds(wrong * this.state.multiplier);
                                                if(wrong >= 5){
                                                    NotificationManager.error("You're not slowing down enough. You need to listen to the portal.");
                                                }else {
                                                    NotificationManager.error('That\'s incorrect.');
                                                }

                                            }
                                            this.setState({wrong, totalWrong: this.state.totalWrong += 1});

                                        }else{
                                            if(sections[this.state.activeSection].questions.length -1 > currentQuestion){
                                                currentQuestion += 1;

                                            }else if(
                                                sections.length - 1 > activeSection
                                            ){
                                                currentQuestion = 0;
                                                activeSection += 1;
                                            }
                                            let totalQuestions = 0;
                                            let answeredQuestions = 0;
                                            
                                            sections.map((s, i) => {
                                                s.questions.map((q) => {
                                                    totalQuestions += 1;
                                                    if(q.userAnswer && q.userAnswer !== ""){
                                                        answeredQuestions += 1;
                                                    }
                                                })
                                            });
                                            sections[this.state.activeSection].questions[index].userAnswer = o;
                                            sections[this.state.activeSection].questions[index].time = Number(this.questionTimer.state.time);
                                            this.questionTimer.reset();
                                            this.setState({
                                                sections,
                                                timeSinceLastQuestion: this.props.userLecture.finish - this.state.userTime,
                                                currentQuestion,
                                                activeSection,
                                                wrong: -1,
                                                totalQuestions,
                                                answeredQuestions
                                            });
                                        }
                                    }else {
                                        let totalQuestions = 0;
                                        let answeredQuestions = 0;
                                        
                                        sections.map((s, i) => {
                                            s.questions.map((q) => {
                                                totalQuestions += 1;
                                                if(q.userAnswer && q.userAnswer !== ""){
                                                    answeredQuestions += 1;
                                                }
                                            })
                                        });
                                        sections[this.state.activeSection].questions[index].userAnswer = o;
                                        // console.log("TIMER", this.questionTimer);
                                        sections[this.state.activeSection].questions[index].time = Number(this.questionTimer.state.time);
                                        this.questionTimer.reset();
                                        this.setState({
                                            sections,
                                            timeSinceLastQuestion: this.props.userLecture.finish - this.state.userTime,
                                            totalQuestions,
                                            answeredQuestions
                                        });
                                    }
                                }}>{o}</button>


                            </li>
                        )
                            }
                    })}

                    <li className="QuestionAble">
                        <button className={`btn btn-answer btn-transparent ${(this.state.showQuestionSection === this.state.activeSection && this.state.showQuestionIndex === index) ? 'selected' : ''}`} onClick={(e) => {
                            e.preventDefault();
                            let {showQuestionSection, showQuestionIndex} = this.state;
                            if(showQuestionSection === this.state.activeSection && showQuestionIndex === index){
                                showQuestionSection = -1;
                                showQuestionIndex = -1;
                            }else{
                                showQuestionSection = this.state.activeSection;
                                showQuestionIndex = index;
                            }

                            this.setState({showQuestionSection, showQuestionIndex});
                        }}>?</button>
                    </li>

                </ul>
                <div className={`question-details ${(this.state.showQuestionSection === this.state.activeSection && this.state.showQuestionIndex === index) ? 'animated slideDown' : 'hidden'} `}>
                    <p>{this.state.sections[this.state.activeSection].questions[index] ? this.state.sections[this.state.activeSection].questions[index].question : ''}</p>
                </div>
            </div>
        )
    }
    
    renderAnswerSheetQuestions = () => {
        return (
            <div className="container">
            <div className={`col-sm-12 columns2 ${this.state.testActive ? '': 'disabled'}`}>
                <div>
                    <div className="table-question sm-bottom0" onClick={(e) => {
                        if(this.state.locked){
                            NotificationManager.error('you\'re going too fast, and you need to slow down. You\'ve already picked ' + this.state.totalWrong.toString() +
                                ' wrong answers so far in this test')
                        }
                    }}>

                        {this.props.userLecture.sections ?
                            this.props.userLecture.sections[this.state.activeSection].questions &&
                            this.props.userLecture.sections[this.state.activeSection].questions.map((question, index) => {
                            return this.renderSingleQuestion(question, index)
                        })
                        : null
                        }

                    </div>
                </div>
            </div>
            </div>
        )
    }

    renderQuestions = () => {
        if(this.props.userLecture.testType === 'answer' || !this.props.userLecture.testType){
            return this.renderAnswerSheetQuestions();
        }
        
    }

    updateCourseUserNextVideo = () => {


        if(!this.state.markedNext) {
            this.setState({markedNext: true}, e => {
                let courseUser = this.props.courseUser[0];
                
                
                this.props.tasks.map(t => {
                    let taskIndex = t.value.map(v => v.value);

                    let realIndex = taskIndex.indexOf(this.props.chapterPart.id);
                    if(realIndex > -1){

                        // So we should set new index to +1 
                        t.currentIndex++;
                        t.progress = parseInt((t.currentIndex / t.value.length) * 100);
                        let data = {
                            type: 'UPDATE_TASK',
                            task: t,
                            token: this.props.user.id
                        };
                        send(data, this.props.socket, this.props.user.id);
                    }
                })

                let alreadyCompleted = courseUser.completedChapterParts.filter(p => p.id === this.props.chapterPart.id);
                if(alreadyCompleted.length > 0){

                    // If a user does this video again, and gets different results, should we update the courseUser object with
                    // the updated chapterPart results?

                }else {
                    let part = this.props.chapterPartTestResults;
                    part.completedOn = new Date();
                    part.duration = this.state.duration;
                    part.userTime = this.state.userTime;
                    part.subjectStarted = courseUser.currentSubjectStart;
                    
                    part.points = 0;
                    part.discussion = false;
                    if(part.finish){
                        if(part.finish > this.state.userTime){
                            part.points += 2;
                        }
                    }

                    if(this.props.chapterPartTestResults.length > 0){
                        part.chapterPartTestResults = this.props.chapterPartTestResults[this.props.chapterPartTestResults.length - 1];
                        if(part.chapterPartTestResults.correctPercent > 90){
                            part.points += 2;
                        }else if(part.chapterPartTestResults.correctPercent > 75){
                            part.points += 1;
                        }
                    }

                    let answeredDiscussion = 0;

                    this.props.discussion.map(d => {
                        let comments = d.DiscussionComment.filter(c => c.profileId === this.props.profile.id);
                        if(comments.length > 0){
                            answeredDiscussion += 1;
                        }
                    })

                    if(answeredDiscussion > 0){
                        part.discussion = answeredDiscussion;
                    }

                    courseUser.completedChapters.push(part);
                    courseUser.currentUserTime = null;
                    courseUser.currentPartVideoTime = null;
                    clearInterval(this.state.timerId);

                    let currentChapter = {};
                    let nextChapterPart = {};
                    let nextChapter = {};
                    let nextSubject = {};
                    
                    if(this.props.chapterPartTestResults.correctPercent >= 80){
                        this.props.nextChapterPart(courseUser, this.props.user.id);
                        //NotificationManager.success("You passed!", "Congratulations!");
                    }
                    
                }
            })
        }
    }

    updateTimer = () => {
        if(this.state.userTime > 0) {
            this.setState({userTime: this.state.userTime - 1});
        }else{
            clearInterval(this.state.timerId);
            this.setState({ranOutOfTime: true, testActive: false});
            // Upate user test with complete fail.
        }
    }

    componentWillReceiveProps(props){
        
        if(props.test.concepts && this.state.timerId){
            this.setState({timerId: null}, () => {
                clearInterval(this.state.timerId);
            });
            
        }

        if(props.test.sections && !this.state.sections){
            this.setState({sections: props.test.sections, initialSection: JSON.parse(JSON.stringify(props.test.sections))})
        }
        this.setState({loadingNext: false});
    }

    startTest = (mode) => {
        if(!this.props.userLecture.chapterVideoId){
            this.setState({
                testActive: true,
                started: true,
                sectionStarted: true
            })
        }else if((mode === "timed" || mode === "training") && this.props.userLecture.Lecture) {
            // console.log("This is now running setuo");
            if (this.state.ranOutOfTime || !this.state.timerId) {
                // Initiate lecture timer
                if(this.state.timerId) {
                    clearInterval(this.state.timerId);
                }
                if(this.state.lockTimer){
                    clearInterval(this.state.lockTimer);
                }
                //let timer = setInterval(this.updateTimer, 1000);

                let totalQuestions = 0;
                this.props.userLecture.sections.map(s => {
                    totalQuestions += s.questions.length;
                })

                let answeredQuestions = 0;
                this.props.userLecture.sections.map(s => {
                    answeredQuestions += s.questions.filter(q => q.userAnswer).length;
                })

                this.setState({
                    switchTo: '',
                    testActive: true,
                    mode: mode,
                    started: true,
                    timed: true,
                    ranOutOfTime: false,
                    userTime: this.props.userLecture.Lecture.finish,
                    showTestResultDetail: false,
                    locked: false,
                    lockTimer: null,
                    lockTime: 0,
                    sectionStarted: true,
                    answeredQuestions: answeredQuestions,
                    totalQuestions: totalQuestions,
                    sections: this.state.sections.map(s => {
                        return {
                            ...s,
                            questions:  s.questions.map(q => {
                                return {...q, userAnswer: null}
                            })
                        }
                    })

                });

            }
        }else if(mode === "training"){
            if(this.state.timerId){
                clearInterval(this.state.timerId);
            }
            this.setState({
                timerId: null,
                switchTo: '',
                mode: 'training',
                testActive: true,
                started: true,
                timed: false,
                ranOutOfTime: false,
                sectionStarted: true,
                showTestResultDetail: false,
                sections: this.state.sections.map(s => {
                    return {
                        ...s,
                        questions:  s.questions.map(q => {
                            return {...q, userAnswer: null}
                        })
                    }
                })
            });
        }else{
            this.setState({started: true, testActive: true, sectionStarted: true});
        }
    }

    toCourseAdmin = () => {
        if(this.props.userSubject){
            if(this.props.userSubject.Subject){
                if(this.props.profile.role === "admin"){
                    this.props.history.push('/course-admin/' + this.props.userSubject.Subject.courseId +'/' + this.props.userSubject.Subject.id);
                }
                    
                }
            
            
            
        }
    }

    decideWhereToGoNext = () => {
        if(this.props.userSubject){
            if(this.props.userSubject.Subject){
                
                    if(this.props.userLecture.passed){
                        if(this.props.userSubject.Subject.type === "review"){
                            this.props.history.push('/my-tests/review');
                        }else{
                            this.props.history.push('/video/' + this.props.userSubject.Subject.courseId +'/' + this.props.userSubject.Subject.id);
                        }
                    }else{
                        if(this.props.userLecture.failBehavior){
                            if(this.props.userLecture.failBehavior === 'lecture'){
                                window.location.reload(true);
                            }else{
                                this.props.history.push('/video/' + this.props.userSubject.Subject.courseId +'/' + this.props.userSubject.Subject.id);
                            }
                        }
                        
                    }
                
                    
                }else{
                    this.props.history.push('/dashboard/')
                }
            
            
            
        }else{
            this.props.history.push('/dashboard/')
        }
    }

    setMode = (mode) => {
        this.setState({switchTo: mode});
    }
    
    render(){
        let timer = null;
        let timerClass = '';
        let behind = 0;
        let ahead = 0;
        let lTimer = null;
        
        let lastQuestion = false;
        
        if(this.props.userLecture){
            if(this.props.userLecture.sections){
                if(this.state.activeSection === this.props.userLecture.sections.length - 1){
                    if(this.state.currentQuestion === this.props.userLecture.sections[this.state.activeSection].questions.length - 1){
                        lastQuestion = true;
                    }
                }
            }
        }


        if(this.state.sections && this.props.userLecture) {

            if(this.props.userLecture.Lecture){
                let seconds = parseInt(this.state.userTime % 60);
                timer = (seconds < 10) ? parseInt(this.state.userTime / 60) + ":" + "0" + seconds.toString()
                    : parseInt(this.state.userTime / 60) + ":" + seconds.toString();

                if(this.state.userTime / this.props.userLecture.Lecture.finish * 100 < 20){
                    timerClass = 'text-warning';
                }else if(this.state.userTime / this.props.userLecture.Lecture.finish * 100 < 10){
                    timerClass = 'text-danger';
                }

                let totalQuestions = 0;
                let answeredQuestions = 0;
                let progressTime = this.props.userLecture.Lecture.finish - this.state.userTime;
                this.state.sections.map(s => {
                    totalQuestions += s.questions.length;
                    answeredQuestions = s.questions.filter(q => q.userAnswer).length;
                })

                let timePerQuestion = this.props.userLecture.Lecture.finish / totalQuestions;


                if(progressTime > (timePerQuestion * answeredQuestions)){
                    behind = progressTime - (timePerQuestion * answeredQuestions);
                }else if(progressTime < (timePerQuestion * answeredQuestions)){
                    ahead = (timePerQuestion * answeredQuestions) - progressTime;
                }




            }

            if(this.state.lockTime){
                let lockSeconds = parseInt(this.state.lockTime % 60);
                lTimer = (lockSeconds < 10) ? parseInt(this.state.lockTime / 60) + ":" + "0" + lockSeconds.toString()
                    : parseInt(this.state.lockTime / 60) + ":" + lockSeconds.toString();
            }
            return (
                <div className={this.props.userLecture.courseSubjectId ? "content-wrapper" : "content-wrapper"} id="content-container">
                    
                    {this.renderContentHeader()}
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={1000 * 300} />
                    {this.state.idleModal ?
                    <IdleModal
                        continue={e => this.setState({idleModal: false})}
                        view={'test'}
                    />
                    : null}

                    
                        <QuestionTimer
                            ref={ref => { this.questionTimer = ref }}
                            start={this.state.started && !this.state.showTestResultDetail}
                        />
                    


                {this.props.userLecture.testType === 'quiz' || this.props.userLecture.testType === 'mcat' ?
                <section className="content no-padding bg-white bg-white-important relative" style={{background: "#fff !important"}}>
                    <div className="progress-diag-quest"><div className="progress-bar-diag-quest" style={{width: this.state.currentProgress.toString() + "%"}}></div> </div>
                    {this.props.userLecture.testType === 'quiz' ?
                    <div className="final_quiz_list sp-top100" style={{minHeight: "90vh"}}>
                        {!this.state.sectionStarted &&
                                        <div className="section-name-slide text-center">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-8 col-sm-offset-2">
                                                        <h1>{this.props.userLecture.sections[this.state.activeSection].name}</h1>
                                                        <div dangerouslySetInnerHTML={{__html: this.props.userLecture.sections[this.state.activeSection].instructions}}></div>
                                                        <div className="sm-top20">
                                                            {this.state.started ?
                                                            <a href="#nogo" id="BeginTest" onClick={() => {
                                                                this.setState({sectionStarted: true});
                                                                this.questionTimer.reset();
                                                            }} className="btn btn-base">Start Answering</a>
                                                            : 
                                                            <a href="#nogo" id="BeginTest" onClick={() => (this.props.userLecture.testMode === 'practice') ? this.startTest('training') : this.startTest('timed')} className="btn btn-base">Start Answering</a>
                                                            
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                        <div className="row">
                            <div className="col-sm-6 col-sm-offset-3">
                            
                                {this.state.started &&
                                    this.renderCurrentQuizQuestion(lastQuestion)}
                                    
                                    {this.state.showTestResultDetail && this.props.userLecture.concepts && 
                                        <TestResultsModal
                                            test={this.props.userLecture}
                                            hideModal={(e) => this.setState({showTestResultDetail: false})}
                                            continue={(e) => this.decideWhereToGoNext()}
                                            toCourseAdmin={e => this.toCourseAdmin()}
                                            onboarding={this.props.onboarding}
                                            profile={this.props.profile}
                                        />
                                    }
                            </div>
                        </div>
                        <div className="sp-20 quiz-control">
                            <div className="row">
                                <div className="col-xs-6">
        
                                </div>
                                <div className="col-xs-6">
                                    {this.state.started &&
                                    <div className="text-right final-mcqs-controls">
                                        {this.state.currentQuestion === 0 && this.state.activeSection === 0 ?
                                        null :
                                        <a className="btn btn-default prev-question" onClick={e => {
                                            if(this.state.currentQuestion > 0){
                                                let self = this;
                                                this.setState({questionClass: 'bounceOutRight'}, () => {
                                                    setTimeout(function(){
                                                        self.setState({currentQuestion: self.state.currentQuestion - 1, showSolution: false, currentAnswer: self.state.sections[self.state.activeSection].questions[self.state.currentQuestion - 1].userAnswer, questionClass: 'bounceInLeft'});
                                                    }, 500);    
                                                })
                                            }
                                        }} href="#nogo">Prev Question</a>
                                        }
                                        {lastQuestion && this.state.currentAnswer !== "" ?
                                            <a className="btn btn-danger score-quiz" disabled={this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length > 0}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            let test = this.props.userLecture;
                                                            test.sections = this.state.sections;
                                                            test.practice = (!this.state.timed);
                                                             let sections = this.props.userLecture.sections;
                                                            let {currentQuestion, currentAnswer, activeSection, wrong, userTime} = this.state;
                                                            
                                                            sections[this.state.activeSection].questions[currentQuestion].userAnswer = currentAnswer;
                                                            sections[this.state.activeSection].questions[currentQuestion].time = Number(this.questionTimer.state.time);
                                                            this.questionTimer.reset();
                                                            if(this.testTimer){
                                                                test.userTime = this.testTimer.current.state.userTime;
                                                                if(this.props.userLecture){
                                                                    if(this.props.userLecture.Lecture){
                                                                        test.finish = this.props.userLecture.Lecture.finish;
                                                                        test.timeLimit = this.props.userLecture.Lecture.timeLimit;
                                                                    }
                                                                }
                                                                
                                                            }

                                                            if (this.props.userLecture.chapterVideoId) {
                                                                test.finishedAt = test.finish - this.state.userTime;
                                                                this.props.scoreSubjectTest(test, this.props.user.user.Profile.id, this.props.user.id);
                                                            } else {
                                                                test.finishedAt = 1;
                                                                this.props.scoreTest(test, this.props.user.user.Profile.id, this.props.user.id);
                                                            }
                                                            this.setState({currentAnswer: null, showTestResultDetail: true, testActive: false, questionClass: 'bounceOutLeft'});

                                                        }} href="#nogo">Score Quiz</a>
                                        : !lastQuestion ?
                                        <a className="btn btn-danger next-question" onClick={e => {
                                            let sections = this.props.userLecture.sections;
                                            let {currentQuestion, currentAnswer, activeSection, wrong, userTime, sectionStarted} = this.state;
                                            
                                            
                                            if(currentAnswer){
                                            
                                                sections[this.state.activeSection].questions[currentQuestion].userAnswer = currentAnswer;
                                                sections[this.state.activeSection].questions[currentQuestion].time = Number(this.questionTimer.state.time);
                                                this.questionTimer.reset();
                                            }
                                            
                                           
                                            
                                            if(sections[this.state.activeSection].questions.length -1 > currentQuestion){
                                                currentQuestion += 1;

                                            }else if(
                                                sections.length - 1 > activeSection
                                            ){
                                                currentQuestion = 0;
                                                activeSection += 1;
                                                sectionStarted = false;
                                            }
                                            
                                            
                                             if(sections[activeSection].questions[currentQuestion].userAnswer){
                                                currentAnswer = sections[activeSection].questions[currentQuestion].userAnswer;
                                            }else{
                                                currentAnswer = '';
                                            }
                                            
                                            let totalQuestions = 0;
                                            let answeredQuestions = 0;
                                            
                                            sections.map((s, i) => {
                                                s.questions.map((q) => {
                                                    totalQuestions += 1;
                                                    if(q.userAnswer && q.userAnswer !== ""){
                                                        answeredQuestions += 1;
                                                    }
                                                })
                                            });
    
                                            let progress = (answeredQuestions / totalQuestions) * 100;
                                            let self = this;
                                            this.setState({questionClass: 'bounceOutLeft'}, () => {
                                                let {sections} = this.state;
                                                let totalQuestions = 0;
                                                    let answeredQuestions = 0;
                                                    
                                                    sections.map((s, i) => {
                                                        s.questions.map((q) => {
                                                            totalQuestions += 1;
                                                            if(q.userAnswer && q.userAnswer !== ""){
                                                                answeredQuestions += 1;
                                                            }
                                                        })
                                                    });
            
                                                    let progress = (answeredQuestions / totalQuestions) * 100;
                                                setTimeout(function(){
                                                    self.setState({
                                                        sections,
                                                        timeSinceLastQuestion: self.props.test.finish - self.state.userTime,
                                                        currentQuestion,
                                                        activeSection,
                                                        currentAnswer: currentAnswer,
                                                        wrong: -1,
                                                        currentProgress: parseInt(progress),
                                                        questionClass: 'bounceInRight',
                                                        answeredQuestions,
                                                        totalQuestions,
                                                        progress,
                                                        showSolution: false,
                                                        sectionStarted
                                                    });
                                                }, 500);    
                                            })
                                            
                                            
                                        }} href="#nogo">Next Question</a>
                                        : null
                                        }
                               
                                    </div>
                                    }
                                </div>
        
                            </div>
                        </div>
        
                    </div>
                    :
                    <div className="questions-section-wrap">
                     {this.state.showTestResultDetail && this.props.userLecture.concepts &&
                                        <TestResultsModal
                                            test={this.props.userLecture}
                                            hideModal={(e) => this.setState({showTestResultDetail: false})}
                                            continue={(e) => this.decideWhereToGoNext()}
                                            toCourseAdmin={e => this.toCourseAdmin()}
                                            profile={this.props.profile}
                                            onboarding={this.props.onboarding}
                                        />
                                    }
                                    {!this.state.sectionStarted &&
                                        <div className="section-name-slide text-center">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-8 col-sm-offset-2">
                                                        <h1>{this.props.userLecture.sections[this.state.activeSection].name}</h1>
                                                        <div dangerouslySetInnerHTML={{__html: this.props.userLecture.sections[this.state.activeSection].instructions}}></div>
                                                        <div className="sm-top20">
                                                            {this.state.started ?
                                                            <a href="#nogo" id="BeginTest" onClick={() => (this.props.userLecture.testMode === 'practice') ? this.setState({sectionStarted: true}) : this.setState({sectionStarted: true})} className="btn btn-base">Start Answering</a>
                                                            : 
                                                            <a href="#nogo" id="BeginTest" onClick={() => (this.props.userLecture.testMode === 'practice') ? this.startTest('training') : this.startTest('timed')} className="btn btn-base">Start Answering</a>
                                                            
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    
                                    
                                    {this.renderCurrentMCATQuestion(lastQuestion)}
                                    
                                    <div tabIndex="-1" className="modal fade in" id="NavigationModal" role="dialog" aria-labelledby="myModalLabel" style={{paddingRight: "16px"}}>
                                        <div className="modal-dialog modal-lg" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <button className="close" aria-label="Close" type="button" data-dismiss="modal"><span aria-hidden="true">Ã—</span></button>
                                                    <h4 className="modal-title" id="myModalLabel">Navigation</h4>
                                                </div>
                                                <div className="modal-body no-padding" style={{height: "500px", overflowY: "scroll"}}>
                                                    <table className="table no-margin">
                                                        <tbody><tr>
                                                            <td>Question No.</td>
                                                            <td>Status</td>
                                                            <td style={{width: "160px"}}>Flag for Review</td>
                                                        </tr>
                                                        
                                                        {this.props.userLecture.sections.map((s, i) => {
                                                            return s.questions.map((q, qi) => {
                                                                return (
                                                                    <tr key={qi}>
                                                                        <td><a  data-dismiss="modal" onClick={e => {
                                                                            let sections = this.props.userLecture.sections;
                                                                            let {currentQuestion, currentAnswer, activeSection, wrong, userTime} = this.state;
                                                                            
                                                                            
                                                                            if(currentAnswer){
                                                                            
                                                                                sections[this.state.activeSection].questions[currentQuestion].userAnswer = currentAnswer;
                                                                                
                                                                                sections[this.state.activeSection].questions[currentQuestion].time = Number(this.questionTimer.state.time);
                                                                                this.questionTimer.reset();
                                                                            }
                                                                            
                                                                           
                                                                            
                                                                            
                                                                                currentQuestion = qi;
                                                                                activeSection = i;
                                                                            
                                                                            
                                                                            
                                                                             if(sections[activeSection].questions[currentQuestion].userAnswer){
                                                                                currentAnswer = sections[activeSection].questions[currentQuestion].userAnswer;
                                                                            }else{
                                                                                currentAnswer = '';
                                                                            }
                                                                            
                                                                            let totalQuestions = 0;
                                                                            let answeredQuestions = 0;
                                                                            
                                                                            sections.map((s, i) => {
                                                                                s.questions.map((q) => {
                                                                                    totalQuestions += 1;
                                                                                    if(q.userAnswer && q.userAnswer !== ""){
                                                                                        answeredQuestions += 1;
                                                                                    }
                                                                                })
                                                                            });
                                    
                                                                            let progress = (answeredQuestions / totalQuestions) * 100;
                                                                            let self = this;
                                                                            
                                                                            self.setState({
                                                                                sections,
                                                                                timeSinceLastQuestion: self.props.test.finish - self.state.userTime,
                                                                                currentQuestion,
                                                                                activeSection,
                                                                                currentAnswer: currentAnswer,
                                                                                wrong: -1,
                                                                                currentProgress: parseInt(progress),
                                                                                questionClass: 'bounceInRight'
                                                                            });
                                                                        }} href="#nogo">Question {((i + 1) * qi) + 1}</a></td>
                                                                        {q.userAnswer ?
                                                                            <td><span className="text-success">Complete</span></td>
                                                                        :
                                                                            <td><span className="text-danger">Incomplete</span></td>
                                                                        }
                                                                        <td><div className="text-info">
                                                                            {this.state.sections[i] ?
                                                                            this.state.sections[i].questions[qi] ?
                                                                            this.state.sections[i].questions[qi].flagged ?
                                                                                <i className="zmdi zmdi-flag" />
                                                                            : null
                                                                            : null
                                                                        : null}    
                                                                        </div></td>
                                                                    </tr>        
                                                                )
                                                            })
                                                        })
                                                        }
                                                                                
                                                        </tbody></table>
                                                </div>
                                                <div className="modal-footer">
                                                    <button className="btn btn-default" type="button" data-dismiss="modal">Close</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                    </div>
                    }
        
                </section>
                
                :
                <section className="content no-padding bg-white">
                    <br/><br/><br/>

                    {!this.state.started && !this.props.userLecture.chapterVideoId ?
                        <div className={"start-test"}>
                            <div dangerouslySetInnerHTML={{__html: this.props.userLecture.instructions}}></div>
                            <button className="btn btn-danger" onClick={() => this.startTest('onboarding')}>Start Test</button>
                        </div>
                        :


                        <div className="nav-tabs-custom no-bg">
                            <ul className="questionstable nav nav-tabs">
                                {this.props.userLecture.sections ?
                                this.props.userLecture.sections.map((section, index) => {
                                    return (
                                        <li className={this.state.activeSection === index ? "active" : ""}>
                                            <a onClick={(e) => {
                                                e.preventDefault();
                                                if (this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length === 0) {
                                                    this.setState({activeSection: index});
                                                }

                                            }}
                                               disabled={this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length > 0}
                                            >{section.name ? section.name : 'Section ' + index}</a>
                                        </li>
                                    )
                                }) : null}



                            </ul>
                            <div className="tab-content no-bg">
                                <div className="tab-pane active no-bg" id="tab_1">
                                    {this.state.showTestResultDetail && this.props.userLecture.concepts &&
                                        <AnswerSheetResults
                                            test={this.props.userLecture}
                                            hideModal={(e) => this.setState({showTestResultDetail: false})}
                                            continue={(e) => this.decideWhereToGoNext()}
                                            toCourseAdmin={e => this.toCourseAdmin()}
                                            profile={this.props.profile}
                                            onboarding={this.props.onboarding}
                                        />
                                    }

                                    <form method="post" id="finalScoreForm">
                                        <div className="row">
                                            {this.renderQuestions()}


                                        </div>


                                        <div className="sp-top30 text-right">
                                            {(this.state.activeSection === this.state.sections.length - 1) ?
                                                <button href="" className="btn btn-danger btn-lg"
                                                        disabled={this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length > 0}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            let test = this.props.userLecture;
                                                            test.sections = this.state.sections;
                                                            test.practice = (!this.state.timed);

                                                            if (this.props.userLecture.chapterVideoId) {
                                                                test.finishedAt = test.finish - this.state.userTime;
                                                                this.props.scoreSubjectTest(test, this.props.user.user.Profile.id, this.props.user.id);
                                                            } else {
                                                                test.finishedAt = 1;
                                                                this.props.scoreTest(test, this.props.user.user.Profile.id, this.props.user.id);
                                                            }
                                                            this.setState({currentAnswer: null, showTestResultDetail: true, testActive: false});

                                                        }}>Submit Test <i className="zmdi zmdi-arrow-forward"></i>
                                                </button>

                                                :

                                                <button href="" className="btn btn-danger btn-lg"
                                                        disabled={this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length > 0}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (this.state.sections[this.state.activeSection].questions.filter(q => !q.userAnswer).length === 0) {
                                                                this.setState({activeSection: this.state.activeSection + 1});
                                                            }

                                                        }}>Next <i className="zmdi zmdi-arrow-forward"></i></button>
                                            }

                                        </div>
                                    </form>
                                </div>
                                <div className="tab-pane" id="tab_2">
                                    #tab_2
                                </div>
                                <div className="tab-pane" id="tab_3">
                                    #tab_3
                                </div>
                                <div className="tab-pane" id="tab_4">
                                    #tab_4
                                </div>
                            </div>
                        </div>
                    }

                </section>
                
                }

                    {this.state.switchTo &&
                    <div
                        className={`bootbox modal fade bootbox-confirm in show`}
                        tabIndex="-1"
                        role="dialog"

                    >
                        <div className="modal-dialog modal-sm">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <button
                                        type="button"
                                        className="bootbox-close-button close"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                        style={{marginTop: -10}}
                                        onClick={() => this.setState({switchTo: ''})}
                                    >
                                        Ã—
                                    </button>
                                    <div className="bootbox-body">
                                        <div className="sp-10 font-16">
                                            Are you sure you want to switch to {this.state.switchTo} mode?  This will reset all questions.
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        data-bb-handler="cancel"
                                        type="button"
                                        className="btn btn-default"
                                        onClick={() => this.setState({switchTo: ''})}
                                    >
                                        No
                                    </button>
                                    <button
                                        data-bb-handler="confirm"
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => {
                                                this.startTest(this.state.switchTo);

                                        }}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    {this.state.ranOutOfTime &&
                    <div
                        className={`bootbox modal fade bootbox-confirm in show`}
                        tabIndex="-1"
                        role="dialog"

                    >
                        <div className="modal-dialog modal-sm">
                            <div className="modal-content">
                                <div className="modal-body">

                                    <div className="bootbox-body">
                                        <div className="sp-10 font-16">
                                           You ran out of time!  Would you like to give it a practice run or are you ready to try again?
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        data-bb-handler="confirm"
                                        type="button"
                                        className="btn btn-default"
                                        onClick={() => {

                                            this.startTest('training');

                                        }}
                                    >
                                        Let's do a practice test
                                    </button>

                                    <button
                                        data-bb-handler="confirm"
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => {
                                            this.startTest('timed');

                                        }}
                                    >
                                        Try again
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            )
        }else{
            return (<div>...</div>)
        }
    }

    renderOld(){

        return (
            <div
                className={(this.props.userLectureId) ? "" : "content-wrapper"}
                id="content-container"
            >
            <div className="panel customPanel no-bg flat">
                <div className="panel-body">
                    {(!this.props.userLectureId) &&
                        <h3 className="font-300 sm-top0">
                            Diagnostic Test
                        </h3>
                    }

                    <p></p>

                    {this.state.showTestResultDetail &&
                        <TestResultsModal
                            test={this.props.userLecture}
                            hideModal={(e) => this.setState({showTestResultDetail: false})}
                            practice={(!this.state.timed)}
                            profile={this.props.profile}
                            toCourseAdmin={e => this.toCourseAdmin()}
                            continue={(e) => {
                            this.props.history.push('/dashboard');
                            }
                            }
                            />
                    }


                    <div className="test-container">
                        {this.props.userLecture.sections[this.state.activeSection].questions &&
                        this.renderTestHeader()}
                        <div className="panel bg-white">


                            <div className="panel-body">

                                <div className="panel-header">


                                </div>

                                {(this.props.userLecture.sections[this.state.activeSection].questions) ?
                                <div className={"question-container"}>
                                    {(this.props.userLecture && this.props.userLecture.currentQuestion <= this.props.userLecture.sections[this.state.activeSection].questions.length) ?
                                        this.mapCurrentQuestion(this.props.userLecture.currentQuestion - 1)
                                        : <div>{this.renderResults()}</div>}
                                </div>
                                    : null }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

export default Test;


// WEBPACK FOOTER //
// ./src/components/UserCourse/Test.js